// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3smIM","filesListContainer":"PosDisputesFiles_filesListContainer__2ZCxz","filesButton":"PosDisputesFiles_filesButton__1IfQG"};